import React from 'react';

import TagsList from './TagsList';

export const TagsTab = () => {
	return <TagsList />;
};
